import _Crumbs from './Crumbs'
import _Crumb from './Crumb'

export const Crumbs = _Crumbs
export const Crumb = _Crumb



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/BreadCrumbs/index.js